<!--
 * @Descripttion: 轮播表属性设置
 * @Author: zenghua.wang
 * @Date: 2021-10-25 10:57:06
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:12:21
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <scrollboad-field :data="data" />
        <config-filter :data="data" />
      </template>
    </api-interface>

    <!-- 轮播表设置 -->
    <el-collapse-item title="轮播表设置">
      <el-form-item label="滚动">
        <el-switch
          v-model="data.option.animation"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="滚动时间(ms)">
        <el-input-number
          v-model="data.option.animationTime"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="滚动方式">
        <el-select
          v-model="data.option.carousel"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in carouselList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <!-- 表头设置 -->
    <el-collapse-item title="表头设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.showHeader"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.headerFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.headerFontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.headerColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="背景颜色">
        <el-color-picker
          v-model="data.option.headerBackgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 表格设置 -->
    <el-collapse-item title="表格设置">
      <el-form-item label="显示行数">
        <el-input-number v-model="data.option.rowNum" />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.rowFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.rowColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="奇行背景颜色">
        <el-color-picker
          v-model="data.option.oddRowBackgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="偶行背景颜色">
        <el-color-picker
          v-model="data.option.evenRowBackgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 排名设置 -->
    <config-color
      title="排名设置"
      :data="data"
    >
      <template #prev>
        <el-form-item label="开启排名">
          <el-switch
            v-model="data.option.index"
            :active-color="theme.active"
            :inactive-color="theme.inactive"
          />
        </el-form-item>

        <el-form-item label="排名占位符">
          <el-input
            v-model="data.option.indexHeader"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item label="颜色目标">
          <el-radio-group
            v-model="data.option.indexStyle"
            size="mini"
          >
            <el-radio-button label="color">字体颜色</el-radio-button>
            <el-radio-button label="backgroundColor">背景色</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </template>
    </config-color>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import configFilter from '@/dragComponents/config/common/filter.vue'
import configColor from '@/dragComponents/config/common/color.vue'

import scrollboadField from './field.vue'

export default {
  name: 'config-scrollboad',
  components: {
    configBase,
    configAuth,
    configColor,
    configFilter,
    apiInterface,
    scrollboadField
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      weightList: component.weightType,
      carouselList: [
        {
          label: '整行',
          value: 'single'
        },
        {
          label: '整屏',
          value: 'page'
        }
      ]
    }
  }
}
</script>
